import { memo } from "react";
import type { AvatarProps as RadixAvatarProps } from '@radix-ui/react-avatar';
import { generateInitials } from "@/utils";
import {
  Fallback as RadixAvatarFallback,
  Image as RadixAvatarImage,
  Root as RadixAvatarRoot,
} from "@radix-ui/react-avatar";
import { cn } from "@/lib/utils";
import { Typography } from "./typography";


export type AvatarProps = {
    url?: string;
    fallbackName?: string;
    alt?: string;
  } & RadixAvatarProps;

const Avatar = ({
  className,
  url,
  fallbackName = "?",
  alt = "User Avatar",
  ...rest
}: AvatarProps) => {
  return (
    <RadixAvatarRoot
      className={cn(
        "size-12 rounded-full inline-flex items-center justify-center shrink-0 align-middle bg-white",
        className
      )}
      {...rest}
    >
      <RadixAvatarImage
        className="object-cover w-full h-full"
        src={url}
        alt={alt}
      />
      <RadixAvatarFallback
        className="w-full h-full uppercase flex items-center justify-center"
        delayMs={0}
      >
        {!!fallbackName && (
          <Typography className="text-secondary" variant="labelSm" asChild>
            <span>{generateInitials(fallbackName)}</span>
          </Typography>
        )}
      </RadixAvatarFallback>
    </RadixAvatarRoot>
  );
};

export default memo(Avatar);
